import { ThemesEffects } from './themes.effect';

export const effects = [ThemesEffects];
export * from './themes.effect';
